module.exports = __webpack_public_path__ + "static/img/img-features-feature-2-game-2.28f42c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-2-game-2.png
// module id = WK74
// module chunks = 18